<template>
  <v-alert
    v-if="validationAlerts.length"
    color="#f9f9f9"
    transition="slide-y-transition"
    class="layout--margin-bottom-none"
  >
    <div class="layout--flex-start">
      <IconExclamation
        class="icon layout--margin-right-xs"
        style="width: 23px; height: 23px; transform:translateY(-3px);"
      />
      <span>
        <strong>You're missing the following info: </strong>
        {{ invalidList }}
        <a href="#" @click.prevent="scrollToFirstInvalid">Jump there</a>
      </span>
    </div>
  </v-alert>
</template>

<script>
import { mapGetters } from "vuex";
import IconExclamation from "../assets/icons/iconAlertBar-Exclamation.svg";

export default {
  components: { IconExclamation },
  computed: {
    ...mapGetters("session", ["validationAlerts"]),
    invalidList() {
      return this.validationAlerts.map(item => item.name).join(", ");
    },
  },
  methods: {
    scrollToFirstInvalid() {
      window.scrollTo({
        top: this.validationAlerts[0].top,
        behavior: "smooth",
      });
    },
  },
};
</script>
